import BSN from 'bootstrap.native';
import ready from '../components/_ready';
import Loader from '../components/_loader';
import { requestFilter, requestPagination } from '../global/_utils';
import loadOnEvent from '../global/loader-on-event';
import scrollAnchor from '../global/scroll-anchor';


ready(() => {
  scrollAnchor('.navbar-dark');
  const loader = new Loader();
  const pathName = window.location.pathname;
  const selectors = {
    loadMore: '.load-more-btn',
    loadMoreDetail: '.load-more-details',
    filter: '.js--filter-section .button-filter',
    searchTitleId: 'proposal-search',
    section: '.js--filter-section',
    filtersModal: 'filters-modal',
    filtersForm: 'filters-form',
  };
  const filtersContainer = document.querySelector(selectors.section);
  const body = document.querySelector('body');

  addLoadMoreEvent();
  addEventListeners();
  updateCount();

  function getFiltersQuery() {
    const filterElement = document.querySelector(selectors.section);

    let edition;
    let theme;
    let subject;
    let municipality;
    let search;

    if (filterElement) {
      edition = filterElement.querySelector('input[name="edition"]:checked');
      theme = filterElement.querySelector('input[name="theme"]:checked');
      subject = filterElement.querySelector('input[name="subject"]:checked');
      municipality = filterElement.querySelector('input[name="municipality"]:checked');
      search = document.getElementById(selectors.searchTitleId);
    }

    const editionValue = edition?.value ?? '';
    const themeValue = theme?.value ?? '';
    const subjectValue = subject?.value ?? '';
    const municipalityValue = municipality?.value ?? '';
    const searchValue = search?.value ?? '';

    return `edition=${editionValue}&theme=${themeValue}&subject=${subjectValue}&municipality=${municipalityValue}&search=${searchValue}`;
  }

  function request(event) {
    loader.show();

    const filters = getFiltersQuery();
    const options = {
      renderLocation: '.all-results-proposals',
      requestPathName: `${pathName}/filter`,
      filters,
      callback: (content) => {
        loadOnEvent(undefined, content);
      },
    };

    requestFilter(event, options)
      .then(() => {
        BSN.initCallback();
        addFilterContainerEvents();
        addLoadMoreEvent();
        updateCount();
        addBodyScroll();
        loader.hide();
      });
  }

  function addLoadMoreEvent() {
    const loadMoreBtn = document.querySelector(selectors.loadMore);
    if (!loadMoreBtn) return;

    loadMoreBtn.addEventListener('click', (event) => {
      loader.show();
      const loadMoreDetailsCurrent = document.querySelector(selectors.loadMoreDetail);
      const { offset } = loadMoreDetailsCurrent.dataset;
      const { limit } = loadMoreDetailsCurrent.dataset;
      const filters = getFiltersQuery();
      const options = {
        renderLocation: '.proposal-results-list',
        requestPathName: `${pathName}/pagination`,
        offset,
        limit,
        filters,
        callback: (content) => {
          loadOnEvent(undefined, content);
        },
      };

      const { parentElement } = loadMoreDetailsCurrent;
      if (parentElement) {
        parentElement.removeChild(loadMoreDetailsCurrent);
      }

      requestPagination(
        event,
        options,
      )
        .then(() => {
          BSN.initCallback();
          canLoadMore();
          loader.hide();
        });
    });
  }

  function updateCount() {
    const filterCount = document.querySelector('.js--filter-count');
    const count = document.querySelectorAll('input[type=radio]:checked')?.length;
    filterCount.textContent = `${count}`;

    if (count > 0) {
      filterCount.classList.remove('d-none');
    } else {
      filterCount.classList.add('d-none');
    }
  }

  // Body Scroll
  function preventBodyScroll() {
    body.classList.add('overflow-hidden');
  }
  function addBodyScroll() {
    body.classList.remove('overflow-hidden');
  }

  // Filter Container Event Listeners
  function addFilterContainerEvents() {
    const btnModal = document.getElementById('btn-modal');
    if (btnModal) {
      btnModal.addEventListener('click', () => {
        if (filtersContainer) {
          filtersContainer.classList.add('show');
          preventBodyScroll();
        }
      });
    }

    const btnCloseModal = document.getElementById('close-filter-modal');
    if (btnCloseModal) {
      btnCloseModal.addEventListener('click', () => {
        if (filtersContainer && filtersContainer.classList.contains('show')) {
          filtersContainer.classList.remove('show');
          addBodyScroll();
        }
      });
    }
  }

  function changeRadioBtn(element, prevId) {
    const el = element;
    let previousId = element.id;

    if (prevId === element.id) {
      el.checked = false;
      previousId = null;
    }
    updateCount();
    return previousId;
  }

  // Filters Event Listeners
  function addFiltersEvents() {
    const editions = document.querySelectorAll('input[name="edition"]');
    const themes = document.querySelectorAll('input[name="theme"]');
    const subjects = document.querySelectorAll('input[name="subject"]');
    const municipalities = document.querySelectorAll('input[name="municipality"]');

    if (editions) {
      let prevEditionCheckedId = document.querySelector('input[name="edition"]:checked')?.id;
      editions.forEach(edition => edition.addEventListener('click', () => {
        prevEditionCheckedId = changeRadioBtn(edition, prevEditionCheckedId);
      }));
    }

    if (themes) {
      let prevThemeCheckedId = document.querySelector('input[name="theme"]:checked')?.id;
      themes.forEach(theme => theme.addEventListener('click', () => {
        prevThemeCheckedId = changeRadioBtn(theme, prevThemeCheckedId);
      }));
    }

    if (subjects) {
      let prevSubjectCheckedId = document.querySelector('input[name="subject"]:checked')?.id;
      subjects.forEach(subject => subject.addEventListener('click', () => {
        prevSubjectCheckedId = changeRadioBtn(subject, prevSubjectCheckedId);
      }));
    }

    if (municipalities) {
      let prevMunicipalityCheckedId = document.querySelector('input[name="municipality"]:checked')?.id;
      municipalities.forEach(municipality => municipality.addEventListener('click', () => {
        prevMunicipalityCheckedId = changeRadioBtn(municipality, prevMunicipalityCheckedId);
      }));
    }
  }

  // Event Listerners
  function addEventListeners() {
    const searchInput = document.getElementById(selectors.searchTitleId);
    if (searchInput) {
      searchInput.addEventListener('blur', (event) => {
        request(event);
      });
    }

    const buttonFilter = document.querySelector(selectors.filter);
    if (buttonFilter) {
      buttonFilter.addEventListener('click', (event) => {
        request(event);
        if (filtersContainer && filtersContainer.classList.contains('show')) {
          filtersContainer.classList.remove('show');
        }
      });
    }

    addFilterContainerEvents();
    addFiltersEvents();
  }

  function canLoadMore() {
    const loadMoreDetailsElement = document.querySelector(selectors.loadMoreDetail);
    if (loadMoreDetailsElement) return;
    const loadMoreBtn = document.querySelector(selectors.loadMore);
    if (!loadMoreBtn) return;
    const { parentElement: loadMoreParentElement } = loadMoreBtn;
    if (loadMoreParentElement) {
      loadMoreParentElement.removeChild(loadMoreBtn);
    }
  }
});
